import HelpLinks from './help-link';

(function ($, dataLayer) {
    $(document).ready(() => {
        HelpLinks.setup('.help-link', '.search-help-content');

        // set up date pickers for advanced search (on results page and in modal)
        $('input.date-input').datepicker({
            dateFormat: 'dd-mm-yy',
            startDate: new Date()
        });

        $('.Education-Tec-Model-TECHomePage .information-holder a').on('click', function (event) {
            dataLayer.push({
                event: 'quick_link_clicked',
                quickLinkText: event.target.innerText,
                quickLinkUrl: event.target.href
            });
        });
    });
}(jQuery, window.dataLayer));



// WEBPACK FOOTER //
// ./src/js/app/common.js